import React, { useState } from "react";
import { Link } from "react-router-dom";
import { clients } from "../assets/data/clients";
import PageHeading from "../components/PageHeading";
import { FaLinkedin, FaTwitterSquare } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";

const Credentials = () => {
  const [show, setShow] = useState(false);
  const [activeId, setActiveId] = useState('')


  // const handleShow = () => setShow(!show);

  const handleShow = (data) => {
    console.log(data, 'id we got')
    setShow(!show)

    setActiveId(data)
  };

  return (
    <>
      <section className="client-page page-header team-member">
        <div className="container">
          <div className="row">
            <PageHeading heading={"Our Credentials"} subheading={"Credentials"} />
          </div>
        </div>
      </section>
      <section className="client-page-data">
        <div className="container">
          <div className="row mb-3">
            <div className="col-12">
              <div className="sec-heading">
                <h2>Our Credentials</h2>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            {clients.map((data, index) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 col-12 my-2">
                  <div target="_blank" className="client-box">
                    <div className="img-box">
                      <img src={data.img1} alt="team" className="img-fluid" />
                    </div>
                    <div className="content-box my-3">
                      <h3>Acquires</h3>

                    </div>
                    <div className="img-box">
                      <img src={data.img2} alt="team" className="img-fluid" />
                    </div>

                    <div className="content-box mt-2">
                      <p>{data.about}</p>
                    </div>
                    <div className="industry" onClick={() => handleShow(data)}>
                      <p>Know More</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* <div className="row mt-4">
            <div className="col-12">
                <div className="team-btn">
                    <button><Link to="">Know More</Link></button>
                </div>
            </div>
          </div> */}

          <Modal
            show={show}
            onHide={handleShow}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              {/* <h1>Hello {activeId.name}</h1> */}
              <img src={activeId?.bigImg} className="img-fluid" />
            </Modal.Body>
          </Modal>
        </div>
      </section>{" "}
    </>
  );
};

export default Credentials;
